import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const INSTAGRAM_LINK = 'https://www.instagram.com/mikebrauninger11/';
const LINKEDIN_LINK = 'https://www.linkedin.com/in/mbrauninger/';
const GITHUB_LINK = 'https://github.com/mbrauninger';

const useStyles = makeStyles((theme) => ({
    footer: {
        width: '100%',
        boxSizing: 'border-box',
        minHeight: 120,
        backgroundColor: '#eef6ff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 24,
        marginTop: 'auto',
        [theme.breakpoints.down('md')]: {
            gap: 20,
        },
        position: 'relative',
        borderTop: '1px solid #d5e4f8',
        paddingLeft: 16,
        paddingRight: 16,
    },
    copyright: {
        color: '#2e538b',
        fontSize: 14,
    },
    socialLinkButton: {
        borderRadius: 10,
        border: '1px solid #d5e4f8',
        color: '#214f99',
        textTransform: 'none',
        fontWeight: 600,
        fontSize: 16,
        padding: '8px 14px',
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: '#e7f0ff',
            borderColor: '#bfd5f7',
        },
    },
}));

export function Footer() {
    function handleLogoClick(url: string) {
        window.open(url, '_blank');
    }
    const classes = useStyles();
    return (
        <Box className={classes.footer}>
            <Box
                sx={{
                    width: '100%',
                    maxWidth: 1200,
                    mx: 'auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: 1.5,
                    py: 2,
                }}
            >
                <Typography className={classes.copyright} sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                    © 2026 Mike Brauninger. All rights reserved.
                </Typography>
                <Stack
                    direction="row"
                    spacing={1.2}
                    useFlexGap
                    alignItems="center"
                    justifyContent={{ xs: 'center', sm: 'flex-end' }}
                    flexWrap="wrap"
                >
                    <Button
                        className={classes.socialLinkButton}
                        sx={{ textTransform: 'none' }}
                        startIcon={<InstagramIcon sx={{ color: 'inherit', fontSize: 24 }} />}
                        onClick={() => handleLogoClick(INSTAGRAM_LINK)}
                    >
                        Instagram
                    </Button>
                    <Button
                        className={classes.socialLinkButton}
                        sx={{ textTransform: 'none' }}
                        startIcon={<LinkedInIcon sx={{ color: 'inherit', fontSize: 24 }} />}
                        onClick={() => handleLogoClick(LINKEDIN_LINK)}
                    >
                        LinkedIn
                    </Button>
                    <Button
                        className={classes.socialLinkButton}
                        sx={{ textTransform: 'none' }}
                        startIcon={<GitHubIcon sx={{ color: 'inherit', fontSize: 24 }} />}
                        onClick={() => handleLogoClick(GITHUB_LINK)}
                    >
                        GitHub
                    </Button>
                </Stack>
            </Box>
        </Box>
    );
}
